import { render, staticRenderFns } from "./SecureCookies.vue?vue&type=template&id=32043328&"
import script from "./SecureCookies.vue?vue&type=script&lang=js&"
export * from "./SecureCookies.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports